module.exports = __webpack_public_path__ + "static/media/sunset_14.74e50b41.webp";